import React from 'react';
import AbstractInput from '../form/abstract-input';

export default class CheckBox extends AbstractInput {
  render() {
    const { divClassName, id, className, label, labelClassName, checked } = this.props;
    const { value, error } = this.state;

    return (
      <div className={divClassName}>
        <input
          id={id}
          className={className}
          checked={checked}
          type="checkbox"
          value={value}
          onFocus={this.focus}
          onBlur={this.blur}
          onChange={this.update}
        />
        <label htmlFor={id} className={labelClassName + (this.state.suspended ? ' suspended' : '')}>
          {label}
          {label && label.length > 0 && error && error.length > 0 ? ' - ' : ''}

          <span style={{ color: '#a01116ff' }}>{error}</span>
        </label>
      </div>
    );
  }
}

CheckBox.defaultProps = {
  ...AbstractInput.defaultProps,
  valueAttribute: (target) => target.checked,
};
